import { useState, useEffect, } from "react";
import Box from '@mui/material/Box';
import { getEndpoint, getMUICache, getUrl, getImageUrl, handleSearchClick, getLoggedUserName, getLoggedUserEmail, logoutUser, getLoggedInFlag, fetchAnchorValue, safeCharAt } from "../../../common/utils";
import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
// import { Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from '@mui/material';
import MainMenuTwo from '../MainMenuTwo/MainMenuTwo'
import DrawerComponentTwo from "../SidebarTwo/DrawerComponentTwo";
import bcrypt from 'bcryptjs-react';
import './HeaderTwo.css';
import { PAGEBUILDER_URLS } from '../../Common/Constant';


HeaderTwo.version = 1000;

HeaderTwo.lang = 'en';
HeaderTwo.langs = [
  'en'
];
HeaderTwo.setLang = (lang: any) => {
  HeaderTwo.lang = lang;
}

Object.defineProperty(HeaderTwo, 'name', {
  writable: true,
  value: 'HeaderTwo'
});

// Define a type for the fetch options
interface FetchOptions {
  method: string;
  headers: {
    'Content-Type': string;
    'p-nonce': string;
  };
  credentials?: RequestCredentials; // Use RequestCredentials type
}

export function HeaderTwo(props: any) {
  const [menuItems, setMenuItems] = useState<any>([]);
  const [headerData, setHeaderData] = useState<any>({});
  const [showMainMenu, setMainMenu] = useState(false);
  const [toogleMenuData, setToggleMenuData] = useState<any>([]);
  const [Closebtn, setClosebtn] = useState<any>(false);
  const [searchValue, setSearchValue] = useState<any>("");
  const [SearchBar, setSearchBar] = useState<any>(false);
  const [isActive, setIsActive] = useState<any>(false);
  const [loggedUserName, setLoggedUserName] = useState<any>("");
  const [loggedUserEmail, setLoggedUserEmail] = useState<any>("");
  const [loginLink, setLoginLink] = useState<any>();
  const [loginEnabled, setLoginEnabled] = useState(false);
  const toggleClass = () => {
    setIsActive(!isActive);
  };

  const endpointHostId = getEndpoint(props, "HEADER_MENU_API");
  const hostId = endpointHostId.queryParams.hostId;

  const {
    onClick,
    showSearch,
    isSticky,
    CONSTANTS,
    noOfHeaderItems,
    anchorLinksValue,
    groupMenuItems
    /*MSID*/
  } = props;

  if (!loginEnabled && props && props.transportData && props.transportData.isLoginEnabled) {
    setLoginEnabled(props.transportData.isLoginEnabled);
  }

  const endpoint = getEndpoint(props, "MAIN");
  const headerMenuEndpoint = getEndpoint(props, "HEADER_MENU_API");
  const togglerEndpoint = getEndpoint(props, "TOGGLER_MENU_API");
  useEffect(() => {
    setLoggedUserName(getLoggedUserName());
    setLoggedUserEmail(getLoggedUserEmail());
    setLoginLink("/login?url=" + encodeURIComponent(window.location.href));
    if (!endpoint.isSSR || !endpoint.SSRDataObj || !headerMenuEndpoint.isSSR || !headerMenuEndpoint.SSRDataObj) {
      fetchComponentData();
    }
    if (!loginEnabled && props && props.transportData && props.transportData.isLoginEnabled) {
      setLoginEnabled(props.transportData.isLoginEnabled);
    }
    setLoginEnabled(getLoggedInFlag());
  }, []);


  if (endpoint.isSSR && endpoint.SSRDataObj && (!headerData || !Object.keys(headerData).length)) {
    setHeaderData(endpoint.SSRDataObj);

    if (isSticky) {
      setTimeout(() => {
        if (typeof document !== 'undefined' && undefined !== document && document && document.getElementsByTagName("header") && document.getElementsByTagName("header")[0])
          document.getElementsByTagName("header")[0].classList.add("sticky");
      })
    }
  }

  if (headerMenuEndpoint.isSSR && headerMenuEndpoint.SSRDataObj && headerMenuEndpoint.SSRDataObj.length && (!menuItems || !menuItems.length)) {
    setMenuItems(headerMenuEndpoint.SSRDataObj);
  }

  if (togglerEndpoint.isSSR && togglerEndpoint.SSRDataObj && togglerEndpoint.SSRDataObj.length && (!toogleMenuData || !toogleMenuData.length)) {
    setToggleMenuData(togglerEndpoint.SSRDataObj);
  }

  const toggleMainMenu = () => {
    if (toogleMenuData.length == 0) {
      getToggleMenuData();
    } else {
      setMainMenu(!showMainMenu);
    }
  }

  const getToggleMenuData = () => {
    let toggleMenuAPIurl = getUrl(props, 0, false, "TOGGLER_MENU_API", true)

    let headerString = '?' + toggleMenuAPIurl.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = { 'p-nonce': headerString };

    fetch(toggleMenuAPIurl, { headers: headers }).then((response) => response.json())
      .then((val) => setToggleMenuData(val))
      .then(() => setMainMenu(true))
  }

  const fetchComponentData = () => {
    const { ENDPOINTS } = props;
    let headerAPI = getUrl(props, 0, false, "MAIN", true, ENDPOINTS[0].queryParams.websiteId, ENDPOINTS[0].queryParams.clientId)
    let menuAPIurl = getUrl(props, 0, false, "HEADER_MENU_API", true)
    // let document = typeof document !== 'undefined' && undefined !== document && document;

    let headerString = `?` + headerAPI.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const customHeaders = {
      'Content-Type': 'application/json',
      'p-nonce': headerString
    };
    var fetchOptions: FetchOptions = {
      method: 'GET',
      headers: customHeaders
    };

    let headerString_menuAPIurl = '?' + menuAPIurl.split("?")[1];
    headerString_menuAPIurl = bcrypt.hashSync(headerString_menuAPIurl, 6);
    const headers_menuAPIurl = { 'p-nonce': headerString_menuAPIurl };

    if (headerAPI.includes('getsiteResources') && !headerAPI.includes("rendering/getsiteResources") &&
      (typeof document !== 'undefined' && undefined !== document && document
        && !PAGEBUILDER_URLS.some(domain => window.location.origin.includes(domain)))) {
      headerAPI = headerAPI.replace("getsiteResources", "rendering/getsiteResources");
    } else { fetchOptions.credentials = "include"; }
    Promise.all([
      fetch(headerAPI, fetchOptions).then((response) => response.json()),
      fetch(menuAPIurl, { headers: headers_menuAPIurl }).then((response) => response.json()),
    ])
      .then(([result1, result2]) => {
        // Handle the results individually
        setHeaderData(result1);
        setMenuItems(result2);
      })
      .catch((error) => {
        // Handle errors here
        console.error('Error fetching data:', error);
      });
  }


  const toggleMenu = () => {
    document.body.classList.add("modal-open");
  };


  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 20);
    });
  }, []);

  const showSearchBar = () => {
    setSearchBar(true)
    setClosebtn(true)
  }
  const closehandler = () => {
    setSearchBar(false)
    setClosebtn(false)
  }

  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission or new window/popup
      handleSearchClick(searchValue, hostId); // Call your search handling function
    }
  }

  const rendertopBar = () => {

    return <AppBar position="relative" color='default' className={scroll ? "bg-black" : "bg-white"}>
      <Toolbar className='header-top'>
        <div className="header-left">
          <div className="sidebar-menu-icon mobileThemeTwoIcon" onClick={() => { toggleMainMenu(); toggleClass(); toggleMenu(); }}>
            <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ mr: 2 }} className={isActive ? 'hamburgerActiveClass' : 'hamburgerInactiveClass'}>
              <MenuIcon />
            </IconButton>
            {/* <Button className="closebtn" onClick={toggleMainMenu}><CloseIcon /></Button> */}
          </div>
          <div id="HeaderlogoIn" className="">
            <Link href="/" aria-label="logo" target={fetchAnchorValue(anchorLinksValue, "/")} className="main-logo">
              {headerData && headerData.mainLogo && <img src={getImageUrl(headerData.mainLogo, "422424", 300,'', "", false, props.CONSTANTS, '3')} alt="logo" />}

            </Link>
            <div className="ThemeTwoLoginMainWrapper">
              {getLoginString()}
            </div>
          </div>
          {showSearch && <div className='themeTwoSearchIcon mobileThemeTwoSearch'>
            {!Closebtn && <SearchIcon onClick={() => showSearchBar()}/>}
            {Closebtn && <CloseIcon onClick={() => closehandler()}/>}

            {SearchBar &&
              <div className='themeSearchMainWrap'>
                <div className="search-main">
                  <div className="search" >
                    {/* <form id="search_sbmt" onSubmit={handleFormSubmit}>
                          <TextField className='themeSearchMainTextFild' id="" placeholder='Search' type='text' onKeyPress={(e) => handleKeyPress(e)} onChange={e => setSearchValue(e.target.value)}
                            InputProps={{
                              endAdornment: <InputAdornment position="end" ><SearchIcon onClick={() => handleSearchClick(searchValue)} /></InputAdornment>
                            }}
                          />
                        </form> */}
                    <TextField
                      id=""
                      placeholder='Search'
                      type='text'
                      onKeyPress={(e) => handleKeyPress(e)}
                      onChange={e => setSearchValue(e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SearchIcon onClick={() => handleSearchClick(searchValue, hostId)} />
                          </InputAdornment>
                        )
                      }}
                    />
                  </div>
                </div>
              </div>
                    }
          </div>}
          {/* <div className='mobileThemeTwoSearch'> 
              {!Closebtn && <SearchIcon onClick={() => showSearchBar()}/>}
              {Closebtn && <CloseIcon onClick={() => closehandler()}/>}

              {(showSearch && SearchBar) &&
              <div className='themeSearchMainWrap'>
                <div className="search-main">
                  <div className="search" >
                  </div>
                </div>
              </div>
            }
            </div> */}
        </div>
      </Toolbar>
    </AppBar>
  }
  let defaultDomainUrl: any = "";
  if (typeof window !== 'undefined' && undefined !== window && window) {
    defaultDomainUrl = "https://" + window.location.hostname;
  } else {
    defaultDomainUrl = (props && props.REQUEST_HOSTNAME) && "https://" + props.REQUEST_HOSTNAME;
  }

  // const getLoginString = () => {
  //   if( loggedUserName ) {
  //     return <>Welcome {loggedUserName} | <a onClick={logoutUser} href="javascript:void(0)">Logout</a></>
  //   }
  //   return <a href={loginLink}>Login</a>
  // }
  const getLoginString = () => {
    if (loginEnabled) {
      if (loggedUserName) {
        return <div className="ThemeTwoWelcomeWrapper">
          <button className="ThemeTwoAfterLoginButton">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M17.33 15.45C18.6914 15.45 19.9971 15.9908 20.9598 16.9535C21.9225 17.9162 22.4633 19.2219 22.4633 20.5833V22.75L22.4571 22.8504C22.4077 23.2448 22.0712 23.55 21.6633 23.55C21.2215 23.55 20.8633 23.1918 20.8633 22.75V20.5833C20.8633 19.6463 20.4911 18.7475 19.8284 18.0849L19.6714 17.9372C19.0273 17.3672 18.195 17.05 17.33 17.05H8.66336L8.44788 17.0566C7.5894 17.109 6.77658 17.4732 6.16492 18.0849C5.50229 18.7475 5.13003 19.6463 5.13003 20.5833V22.75L5.1238 22.8504C5.07443 23.2448 4.73787 23.55 4.33003 23.55C3.8882 23.55 3.53003 23.1918 3.53003 22.75V20.5833L3.53634 20.3288C3.59928 19.06 4.13103 17.8561 5.03355 16.9535C5.99623 15.9908 7.30192 15.45 8.66336 15.45H17.33Z"
                fill="white" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M12.7863 12.7122C10.0519 12.5985 7.87 10.3457 7.87 7.58334L7.8745 7.36635C7.98821 4.63193 10.241 2.45001 13.0033 2.45001L13.2203 2.45452C15.9547 2.56823 18.1367 4.82098 18.1367 7.58334L18.1322 7.80034C18.0185 10.5348 15.7657 12.7167 13.0033 12.7167L12.7863 12.7122ZM13.1972 11.1115C15.0584 11.0108 16.5367 9.46971 16.5367 7.58334L16.5314 7.38948C16.4308 5.52824 14.8897 4.05001 13.0033 4.05001L12.8095 4.05524C10.9482 4.15588 9.47 5.69699 9.47 7.58334L9.47522 7.77721C9.57587 9.63846 11.117 11.1167 13.0033 11.1167L13.1972 11.1115Z"
                fill="white" />
            </svg>
            <span>{safeCharAt(loggedUserName)}</span>
          </button>
          <ul className="ThemeTwoListLog">
            <li className="ThemeTwoDesktopUserName">{loggedUserName} <span className="ThemeTwoDesktopUserEmail">{loggedUserEmail}</span></li>
            {/* <li className="ThemeTwoDesktopUserEmail">{loggedUserEmail}</li> */}
            <li> <a onClick={logoutUser} href="javascript:void(0)">Logout</a></li>
          </ul>
        </div>
      }
      return <div className="ThemeTwoLoginWrapper">
        <a href={loginLink} className="ThemeThreeLoginAnchor"><svg width="26" height="26" viewBox="0 0 26 26" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M17.33 15.45C18.6914 15.45 19.9971 15.9908 20.9598 16.9535C21.9225 17.9162 22.4633 19.2219 22.4633 20.5833V22.75L22.4571 22.8504C22.4077 23.2448 22.0712 23.55 21.6633 23.55C21.2215 23.55 20.8633 23.1918 20.8633 22.75V20.5833C20.8633 19.6463 20.4911 18.7475 19.8284 18.0849L19.6714 17.9372C19.0273 17.3672 18.195 17.05 17.33 17.05H8.66336L8.44788 17.0566C7.5894 17.109 6.77658 17.4732 6.16492 18.0849C5.50229 18.7475 5.13003 19.6463 5.13003 20.5833V22.75L5.1238 22.8504C5.07443 23.2448 4.73787 23.55 4.33003 23.55C3.8882 23.55 3.53003 23.1918 3.53003 22.75V20.5833L3.53634 20.3288C3.59928 19.06 4.13103 17.8561 5.03355 16.9535C5.99623 15.9908 7.30192 15.45 8.66336 15.45H17.33Z"
            fill="white" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12.7863 12.7122C10.0519 12.5985 7.87 10.3457 7.87 7.58334L7.8745 7.36635C7.98821 4.63193 10.241 2.45001 13.0033 2.45001L13.2203 2.45452C15.9547 2.56823 18.1367 4.82098 18.1367 7.58334L18.1322 7.80034C18.0185 10.5348 15.7657 12.7167 13.0033 12.7167L12.7863 12.7122ZM13.1972 11.1115C15.0584 11.0108 16.5367 9.46971 16.5367 7.58334L16.5314 7.38948C16.4308 5.52824 14.8897 4.05001 13.0033 4.05001L12.8095 4.05524C10.9482 4.15588 9.47 5.69699 9.47 7.58334L9.47522 7.77721C9.57587 9.63846 11.117 11.1167 13.0033 11.1167L13.1972 11.1115Z"
            fill="white" />
        </svg>
          <span>login</span>
        </a>
      </div>
    }
  }
  return (
    <div className="card_wrapper themeTwoMainHeaderWrap" onClick={onClick}>
      <CacheProvider value={getMUICache()}>

        <Box sx={{ flexGrow: 1 }} className="header themeTwoHeaderWrap">
          <Grid  container direction="column">
            <Grid item md={12}>
              {rendertopBar()}
            </Grid>
            <Grid item md={12} className='menu-wrap'>
              {headerData && Object.keys(headerData).length &&
                <MainMenuTwo
                  menuItems={menuItems}
                  domainUrl={defaultDomainUrl}
                  toggleMainMenu={toggleMainMenu}
                  headerMenuEndpoint={headerMenuEndpoint}
                  cdsDomain={CONSTANTS.CDS_API}
                  L1BgColor={props.L1BgColor}
                  L1TextColor={props.L1TextColor}
                  L2BgColor={props.L2BgColor}
                  L2TextColor={props.L2TextColor}
                  HamburgerIconColor={props.HamburgerIconColor}
                  SearchIconColor={props.SearchIconColor}
                  showSearch={showSearch}
                  noOfHeaderItems={noOfHeaderItems}
                  hostId={hostId}
                  anchorLinksValue={anchorLinksValue}
                  groupMenuItems={groupMenuItems}
                />}
            </Grid>
          </Grid>

          {showMainMenu &&
            <Grid item md={12} className='menu-wrap' style={{ backgroundColor: props.HamburgerBgColor }}>
              <DrawerComponentTwo props={props} toggleMainMenu={toggleMainMenu} menuItems={toogleMenuData} domainUrl={defaultDomainUrl} HamburgerBgColor={props.HamburgerBgColor} HamburgerTextColor={props.HamburgerTextColor} hostId={hostId} anchorLinksValue={anchorLinksValue} />
            </Grid>


          }
        </Box>
      </CacheProvider>
    </div>
  );
}